import React, { useEffect, useRef, useState } from 'react';
import { siteConfig } from '../constant/siteConfig';
import { useLanguage } from '../i18n/LanguageContext';

const languages = {
    en: {
        name: 'English',
        src: 'https://flagcdn.com/w40/us.png',
    },
    it: {
        name: 'Italiano',
        src: 'https://flagcdn.com/w40/it.png',
    },
    es: {
        name: 'Español',
        src: 'https://flagcdn.com/w40/es.png',
    },
};

const NavigationBar = () => {
    const { language, setLanguage } = useLanguage();
    const activeLanguage = languages[language] || languages.en;
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };

        const handleEscape = (event) => {
            if (event.key === 'Escape') {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchstart', handleClickOutside);
        document.addEventListener('keydown', handleEscape);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
            document.removeEventListener('keydown', handleEscape);
        };
    }, []);

    const handleLanguageSelect = (langCode) => {
        setLanguage(langCode);
        setIsDropdownOpen(false);
    };

    return (
        <div
            className="navbar px-4 sm:px-10 text-neutral-content"
            style={{ backgroundColor: siteConfig.brandColors.primary }}
        >
            <div className="flex w-full items-center justify-between gap-4">

                {/* Logo Section */}
                <a href="/" className="flex cursor-pointer items-center space-x-3">
                    <span className="block w-[60px]">
                        <img
                            src={siteConfig.brandLogoUrl}
                            alt={`${siteConfig.companyName} Logo`}
                            className="block w-full h-auto"
                        />
                    </span>
                    <span className="text-sm font-bold sm:text-lg text-white">
                        {siteConfig.appName}
                    </span>
                </a>

                {/* Language Dropdown */}
                <div ref={dropdownRef} className="relative">
                    <button
                        type="button"
                        onClick={() => setIsDropdownOpen((prev) => !prev)}
                        aria-expanded={isDropdownOpen}
                        aria-haspopup="menu"
                        className="btn btn-sm bg-white p-2 text-black hover:bg-gray-100 border border-gray-300 min-h-0 h-auto"
                    >
                        <div className="flex items-center gap-2">
                            <img
                                src={activeLanguage.src}
                                alt={activeLanguage.name}
                                className="h-5 w-7 rounded-sm object-cover"
                            />
                            <span className="text-sm font-medium">
                                {activeLanguage.name}
                            </span>
                        </div>
                    </button>

                    {isDropdownOpen && (
                        <ul
                            role="menu"
                            className="absolute right-0 z-[100] mt-2 w-44 rounded-md bg-white p-2 shadow-lg border border-gray-200 text-black"
                        >
                            {Object.entries(languages).map(([langCode, lang]) => (
                                <li key={langCode}>
                                    <button
                                        type="button"
                                        onClick={() => handleLanguageSelect(langCode)}
                                        className={`flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-all
                                            ${language === langCode
                                                ? 'bg-gray-100 font-semibold'
                                                : 'hover:bg-gray-50'
                                            }`}
                                    >
                                        <img
                                            src={lang.src}
                                            alt={lang.name}
                                            className="h-5 w-7 rounded-sm object-cover"
                                        />
                                        <span>{lang.name}</span>
                                    </button>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        </div>
    );
};

export default NavigationBar;
